<script>
import i18n from "@/plugins/i18n";
import { SidebarMenu } from 'vue-sidebar-menu';
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
      SidebarMenu
    },

    data() {
        return {
            hasSU1: false,
            hasSU2: false,

            clickedSU1: false,
            clickedSU2: false,

            companyLicence: null,
            collapsed: false,
            planID: null,
            planActive: false,
            companyRoleId: 0,
            isSupplier: false,

            planModal: false,
            surveyModal: false,
        }
    },

    watch: {
        planModal(val) {
            if (val === true) {
                this.$refs.planWarningPopup.openPopup();
            }
        },

        surveyModal(val, oldVal) {
            if (val === true) {
                this.$refs.surveyWarningPopup.openPopup();
            }
        },
    },

    computed: {
        buffer_planID() {
            return this.planID;
        },

        buffer_hasSU1() {
            return this.hasSU1;
        },

        buffer_hasSU2() {
            return this.hasSU2;
        },

        menu() { 
            return [
                {
                    icon: "fa-solid fa-bars",
                    class: "toggle-close-navbar"
                },
                {
                    hidden: this.planID === 4,
                    title: 'Upgrade',
                    icon: 'fi fi-rr-star-christmas',
                    id: 'upgrade-button',
                    class: 'upgrade-button',
                },
                {
                    href: '/dashboard',
                    title: i18n.t('sideBar.education.homepage'),
                    icon: 'fa-solid fa-house'
                },
                {
                    href: '/company',
                    title: i18n.t('companyOperations.companyOperations'),
                    icon: 'fa-solid fa-building-user',
                },
                {
                    href: '/stakeholders',
                    title: i18n.t('sideBar.settings.userCompany'),
                    icon: 'fa-solid fa-users',
                },
                {
                    href: '/my-companies',
                    title: i18n.t('sideBar.menuTitles.myCompanies'),
                    icon: 'fi fi-ss-city',
                    class: 'navbar-border'
                },
                {
                    href: '/sdg-alignment-surveys',
                    title: i18n.t('su1Results.navbarName'),
                    icon: 'fa-solid fa-square-poll-vertical'
                },
                {
                    href: this.buffer_hasSU1 == true ? '/su1Results' : null,
                    title: i18n.t('su2Results.result'),
                    icon: 'fa-solid fa-magnifying-glass-chart',
                    class: "analysis-results-navbar",
                    id: "need-su1"
                },
                {
                    href: '/materiality-analysis-surveys',
                    title: i18n.t('su2Results.navbarName'),
                    icon: 'fi fi-ss-chart-scatter-bubble',
                },
                {
                    href: this.buffer_hasSU2 == true ? '/su2Results' : null,
                    title: i18n.t('su2Results.result'),
                    icon: 'fa-solid fa-magnifying-glass-chart',
                    class: 'analysis-results-navbar',
                    id: "need-su2"
                },
                {
                    title: i18n.t('sideBar.sustainability.reports'),
                    icon: 'fi fi-sr-memo',
                    href: this.buffer_planID == 1 ? null : '/reports',
                    id: 'plan-not-met',
                    class: 'navbar-border'
                },
                {
                    href: this.buffer_planID == 1 || this.buffer_planID == 2 ? null : '/kpi-metrics',
                    title: i18n.t('sideBar.sustainability.kpimetrics'),
                    icon: 'fa-solid fa-chart-line',
                    id: 'plan-not-met2'
                },
                {
                    href: this.buffer_planID == 1 || this.buffer_planID == 2 ? null : '/kpi-monitoring',
                    title: i18n.t('sideBar.sustainability.kpiMonitor'),
                    icon: 'fa-solid fa-magnifying-glass-chart',
                    id: 'plan-not-met2',
                    class: ' analysis-results-navbar',
                },
                {
                    href: '/requested-metrics',
                    title: i18n.t('sideBar.sustainability.requestedMetrics'),
                    icon: 'fa-solid fa-clipboard-list',
                    hidden: !this.isSupplier,
                    class: ' analysis-results-navbar',
                },
                {
                    href: this.buffer_planID == 1 || this.buffer_planID == 2 ? null : '/supplier-metrics',
                    title: i18n.t('sideBar.sustainability.kpiSupplier'),
                    icon: 'fi fi-rr-supplier-alt',
                    id: 'plan-not-met2',
                    class: ' analysis-results-navbar',
                    hidden: (this.companyRoleId == 6)
                },
                {
                    href: (this.buffer_planID == 1 || this.buffer_planID == 2  || this.buffer_planID == 3) ? null : '/generate-sections',
                    title: i18n.t('sideBar.sustainability.generateSections'),
                    id: 'plan-not-met3',
                    class: 'navbar-border',
                    icon: "fa-solid fa-file-invoice"
                },
                /* {
                    href: '/project-search-engine',
                    title: i18n.t('sideBar.projects.projectSearchEngine'),
                    icon: 'fa-solid fa-magnifying-glass',
                    class: 'navbar-border'
                }, */
                {
                    href: '/documents',
                    title: i18n.t('documents.title'),
                    icon: 'fa-solid fa-list',
                },
            ]
        }
    },

    mounted(){
        this.checkForSurveys();
        this._getCompanyLicenceState();
        this._checkIsSupplier();
    },

    methods: {
        onItemClick(event, item, node) {
            const is_starter = this.planID == 1;
            const is_above_starter = this.planID == 2 || this.planID == 3 || this.planID == 4;
            const is_above_standard = this.planID == 3 || this.planID == 4;
            const is_enterprise = this.planID == 4;

            if(item.class == 'toggle-close-navbar'){
                this.collapsed = !this.collapsed;
                this.setNavbarOpen(this.collapsed);
            }
            if(item.id == 'plan-not-met' && (is_starter || (is_above_starter && this.planActive == false)) ){
                this.planModal = true;
                return;
            }
            if(item.id == 'plan-not-met2' && (!is_above_standard || (is_above_standard && this.planActive == false))){
                this.planModal = true;
                return;
            }
            if(item.id == 'plan-not-met3' && (!is_enterprise || (is_enterprise && this.planActive == false))){
                this.planModal = true;
                return;
            }
            if (item.id == "need-su1" && !this.hasSU1) {
                this.clickedSU1 = true;
                this.openSurveyModal(true);
                return;
            }
            if (item.id == "need-su2" && !this.hasSU2) {
                this.clickedSU2 = true;
                this.openSurveyModal(true);
                return;
            }
            if(item.id == 'upgrade-button'){
                this.goToPlans();
            }
        },

        goToPlans(){
            window.open('https://www.sustainfinity.com/plans-and-pricing', '_blank')
        },

        ...mapGetters("app", ["getCompanyLicence"]),

        _getCompanyLicenceState() {
            const licence = this.getCompanyLicence();
            
            this.planID = licence.plan_id;
            this.planActive = licence.is_active;
            this.companyRoleId = licence.company_role_id;
        },

        ...mapActions("results", ["getLastSU1Survey", "getLastSU2Survey"]),

        ...mapActions('app', [
            'setNavbarOpen',
        ]),

        ...mapActions('company', [
            'checkIsSupplier',
        ]),

        async _checkIsSupplier() {
            try {
                const res = await this.checkIsSupplier();
                this.isSupplier = !!(res && res.data && res.data.is_supplier);
            } catch (e) {
                this.isSupplier = false;
            }
        },

        checkForSurveys() {
            const params = {
              company_id: Number(this.$user.company_id),
              created_by: Number(this.$user.user_id),
              is_approved: true
            };

            this.getLastSU1Survey(params)
                .then( res => {
                  this.hasSU1 = true;
                })
                .catch(({ response }) => {
                  throw new Error(response.message);
                })
                .finally(() => {
                    this.$forceUpdate();
                })

            this.getLastSU2Survey(params)
                .then( res => {
                  this.hasSU2 = true;
                })
                .catch(({ response }) => {
                  throw new Error(response.message);
                })
                .finally(() => {
                    this.$forceUpdate();
                })

        },

        surveyRedirectController() {
            if (this.clickedSU1) {
                this.$router.push("/sdg-alignment-surveys");
            } else if (this.clickedSU2) {
                this.$router.push("/materiality-analysis-surveys");
            } else {
                throw new Error("Unexpected behavior at survey controller!");
            }
        },

        openSurveyModal(bool) {
            if (bool == true) {
                this.surveyModal = true;
            } else {
                this.surveyModal = false;
                this.clickedSU1 = false;
                this.clickedSU2 = false;
            }
        }
    }
}
</script>

<template>
    <div style="height: 100%;">
        <sidebar-menu 
            :menu="menu" 
            :collapsed="collapsed" 
            :relative="true"
            width="100%"
            widthCollapsed="5em"
            :hideToggle="true"
            :disableHover="true"
            @item-click="onItemClick"
        />

        <sust-popup
            ref="planWarningPopup"
            @ok="goToPlans"
            size="md"
            :title="$t('sideBar.warnings.su2Plan')"
            :cancelButtonText="$t('stepValidations.close')"
            :okButtonText="$t('stepValidations.redirect')"
        >
            {{ $t('sideBar.warnings.redirect') }}
        </sust-popup>

        <sust-popup
            ref="surveyWarningPopup"
            @ok="surveyRedirectController"
            @onHide="openSurveyModal(false)"
            size="md"
            :title="$t('sideBar.warnings.noSurvey')"
            :cancelButtonText="$t('stepValidations.close')"
            :okButtonText="$t('stepValidations.redirect')"
        >
            {{ $t('sideBar.warnings.surveyRedirect') }}
        </sust-popup>
    </div>
    
</template>


<style lang="scss">

.v-sidebar-menu {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    z-index: 999;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    text-align: left;
    -webkit-transition: 0.3s max-width ease;
    transition: 0.3s max-width ease;
    overflow: hidden;
}

.v-sidebar-menu * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.v-sidebar-menu .vsm--scroll-wrapper {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden
}

.v-sidebar-menu .vsm--dropdown>.vsm--list {
    padding: 5px !important
}

.v-sidebar-menu .vsm--item {
    position: relative;
    display: block;
    width: 100%;
    white-space: nowrap;
}

.v-sidebar-menu .vsm--link {
    cursor: pointer;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px !important;
    font-weight: 400;
    padding: 6px !important;
    line-height: 30px;
    text-decoration: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    z-index: 20;
    -webkit-transition: 0.3s all ease;
    transition: 0.3s all ease
}

.v-sidebar-menu .vsm--link_exact-active,
.v-sidebar-menu .vsm--link_active {
    font-weight: 600;
    background-color: #102734;
}

.v-sidebar-menu .vsm--link_disabled {
    opacity: 0.4;
    pointer-events: none
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
    padding-left: 1em; /* was not present before, added on 26.03.2024 by ata to make the upgrade button look more aligned with the rest of the buttons*/
    height: 30px;
    line-height: 30px;
    width: 30px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    text-align: center;
    border-radius: 3px;
}

.v-sidebar-menu .vsm--icon {
    display: inline-block;
    margin-right: 10px
}

.v-sidebar-menu .vsm--title {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1
}

.v-sidebar-menu .vsm--arrow {
    width: 30px;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    -webkit-transition: 0.3s -webkit-transform ease;
    transition: 0.3s -webkit-transform ease;
    transition: 0.3s transform ease;
    transition: 0.3s transform ease, 0.3s -webkit-transform ease
}

.v-sidebar-menu .vsm--arrow:after {
    content: '\f105';
    font-family: 'Font Awesome 5 Free'
}

.v-sidebar-menu .vsm--arrow_open {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.v-sidebar-menu .vsm--arrow_slot:after {
    display: none
}

.v-sidebar-menu .vsm--header {
    font-size: 14px !important;
    font-weight: 600;
    padding: 10px;
    white-space: nowrap;
    text-transform: uppercase
}

.v-sidebar-menu .vsm--badge_default {
    padding: 0px 6px;
    font-size: 14px !important;
    border-radius: 3px;
    height: 20px;
    line-height: 20px;
    font-weight: 600;
    text-transform: uppercase
}

.v-sidebar-menu .vsm--toggle-btn {
    display: block;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    height: 50px;
    cursor: pointer;
    border: none;
    width: 100%;
    padding-left: 6px !important;
}

.v-sidebar-menu .vsm--toggle-btn:after {
    content: '\f337';
    font-family: 'Font Awesome 5 Free'
}

.v-sidebar-menu .vsm--toggle-btn_slot:after {
    display: none
}

.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover,
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover {
    background-color: transparent !important
}

.v-sidebar-menu.vsm_rtl {
    right: 0;
    left: inherit;
    text-align: right;
    direction: rtl
}

.v-sidebar-menu.vsm_rtl .vsm--icon {
    margin-left: 10px !important;
    margin-right: 0px
}

.v-sidebar-menu.vsm_relative {
    position: relative;
    height: 100%
}

.v-sidebar-menu .expand-enter-active,
.v-sidebar-menu .expand-leave-active {
    -webkit-transition: height 0.3s ease;
    transition: height 0.3s ease;
    overflow: hidden
}

.v-sidebar-menu .expand-enter,
.v-sidebar-menu .expand-leave-to {
    height: 0 !important
}

.v-sidebar-menu .slide-animation-enter-active {
    -webkit-transition: width 0.3s ease;
    transition: width 0.3s ease
}

.v-sidebar-menu .slide-animation-leave-active {
    -webkit-transition: width 0.3s ease;
    transition: width 0.3s ease
}

.v-sidebar-menu .slide-animation-enter,
.v-sidebar-menu .slide-animation-leave-to {
    width: 0 !important
}

.v-sidebar-menu .fade-animation-enter-active {
    -webkit-transition: opacity 0.3s ease, visibility 0.3s ease;
    transition: opacity 0.3s ease, visibility 0.3s ease
}

.v-sidebar-menu .fade-animation-leave-active {
    -webkit-transition: opacity 0.3s ease, visibility 0.3s ease;
    transition: opacity 0.3s ease, visibility 0.3s ease
}

.v-sidebar-menu .fade-animation-enter,
.v-sidebar-menu .fade-animation-leave-to {
    opacity: 0 !important;
    visibility: hidden !important
}

.v-sidebar-menu .vsm--mobile-item>.vsm--item {
    padding: 0 !important;
    margin: 0 !important
}

.v-sidebar-menu .vsm--mobile-item>.vsm--item>.vsm--link {
    margin: 0 !important;
    background-color: transparent !important;
    line-height: 30px !important
}

.v-sidebar-menu {
    background-color: #023047 !important
}

.v-sidebar-menu .vsm--link {
    color: #fff
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
    -webkit-box-shadow: 3px 0px 0px 0px #054a6d inset !important;
    box-shadow: 3px 0px 0px 0px #054a6d inset !important
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
    background-color: transparent
}

.v-sidebar-menu .vsm--link_hover,
.v-sidebar-menu .vsm--link:hover {
    background-color: rgba(30, 30, 33, 0.5)
}

.v-sidebar-menu .vsm--link_mobile-item {
    color: #023047
}

.v-sidebar-menu .vsm--link_mobile-item.vsm--link_hover,
.v-sidebar-menu .vsm--link_mobile-item:hover {
    color: #023047;
    background-color: rgba(30, 30, 33, 0.5)
}

.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon {
    color: #fff;
    background-color: rgba(30, 30, 33, 0.5);
}

.v-sidebar-menu .vsm--dropdown .vsm--list {
    background-color: #043953 !important
}

.v-sidebar-menu .vsm--mobile-bg {
    background-color: #023047 !important
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    color: #fff;
    background-color: #023047 !important
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon {
    background-color: transparent !important
}

.v-sidebar-menu.vsm_rtl .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu.vsm_rtl .vsm--link_level-1.vsm--link_exact-active {
    -webkit-box-shadow: -3px 0px 0px 0px #023047 inset !important;
    box-shadow: -3px 0px 0px 0px #023047 inset !important
}

.v-sidebar-menu .vsm--header {
    color: rgba(255, 255, 255, 0.7)
}

.v-sidebar-menu .vsm--badge_default {
    color: #fff;
    background-color: #1e1e21 !important
}

.v-sidebar-menu .vsm--toggle-btn {
    color: #fff;
    background-color: #043852 !important
}

.v-sidebar-menu.vsm_white-theme {
    background-color: #fff
}

.v-sidebar-menu.vsm_white-theme .vsm--link {
    color: #262626
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active {
    -webkit-box-shadow: 3px 0px 0px 0px #4285f4 inset;
    box-shadow: 3px 0px 0px 0px #4285f4 inset
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active .vsm--icon,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active .vsm--icon {
    color: #fff;
    background-color: #262626
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1 .vsm--icon {
    background-color: #bbc5d6
}

.v-sidebar-menu.vsm_white-theme .vsm--link_hover,
.v-sidebar-menu.vsm_white-theme .vsm--link:hover {
    background-color: rgba(242, 242, 242, 0.5)
}

.v-sidebar-menu.vsm_white-theme .vsm--link_mobile-item {
    color: #fff
}

.v-sidebar-menu.vsm_white-theme .vsm--link_mobile-item.vsm--link_hover,
.v-sidebar-menu.vsm_white-theme .vsm--link_mobile-item:hover {
    color: #fff
}

.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,
.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1:hover .vsm--icon {
    color: #fff;
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme .vsm--dropdown .vsm--list {
    background-color: #e3e3e3
}

.v-sidebar-menu.vsm_white-theme .vsm--mobile-bg {
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    color: #fff;
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon {
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme.vsm_rtl .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu.vsm_white-theme.vsm_rtl .vsm--link_level-1.vsm--link_exact-active {
    -webkit-box-shadow: -3px 0px 0px 0px #4285f4 inset;
    box-shadow: -3px 0px 0px 0px #4285f4 inset
}

.v-sidebar-menu.vsm_white-theme .vsm--header {
    color: rgba(38, 38, 38, 0.7)
}

.v-sidebar-menu.vsm_white-theme .vsm--badge_default {
    color: #262626;
    background-color: #f2f2f2
}

.v-sidebar-menu.vsm_white-theme .vsm--toggle-btn {
    color: #262626;
    background-color: #f2f2f2
}

::-webkit-scrollbar{
  margin: 0 !important;
  width: 5px !important;
  background: aliceblue !important;
}
::-webkit-scrollbar-thumb{
  background: #035a86 !important;
}

/*# sourceMappingURL=vue-sidebar-menu.css.map*/



.navbar-border{
    border-bottom: thin solid white !important;
}

.vsm_expanded .toggle-close-navbar .vsm--icon{
    padding-left: 45%; /* ??? */
}
.vsm--link_hover .toggle-close-navbar .vsm--icon{
    padding-left: 45%; /* ??? */
}

.analysis-results-navbar{
    margin-left: 5% !important;
}


.vsm_expanded .upgrade-button {
    border-radius: 2em;
    border: thin solid white;
    width: 10em;
    margin-left: 1em;

    box-shadow: 0 0 .6em .1em white inset;

    &:hover {
        background: linear-gradient(to bottom, var(--sustainfinity-green), var(--sustainfinity-blue));
        box-shadow: 0 0 .6em .1em white;
    }

    > i {
        padding-top: .2em !important;
        padding-left: 0 !important;
    }
}
.vsm_collapsed .upgrade-button .vsm--icon{
    text-align: center;
    border-radius: 1.5em;
    border: thin solid white;
    margin-left: .3em;
    padding-left: 0 !important;

    box-shadow: 0 0 .6em .1em white inset;

    &:hover {
        background-color: 0 !important;
        background: linear-gradient(to bottom, var(--sustainfinity-green), var(--sustainfinity-blue));
        box-shadow: 0 0 .6em .1em white;
    }
}
</style>